import React from 'react';
import {
  Container,
  Box,
  CheckIcon,
  Label,
} from './styles';

export default function Checkbox({ label, checked = false, onChange }) {
  return (
    <Container onClick={() => onChange(!checked)}>
      <Box checked={checked}>
        {checked && <CheckIcon>✔</CheckIcon>}
      </Box>

      <Label checked={checked}>{label}</Label>
    </Container>
  );
}
